"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const i = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.5 11h-19c-.276 0-.5.221-.5.494v1.113c0 .273.225.494.5.494h19c.276 0 .5-.222.5-.495v-1.112a.496.496 0 0 0-.5-.494",
        clipRule: "evenodd"
      }
    )
  }
), c = l(i);
export {
  c as Minus,
  c as default
};
